import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LEARN_ROUTES } from '../config/learnRoutes';
import useEntryConfig from '../hooks/useEntryConfig';

// The root (learn.novara.tech) funnels straight into the product so no one lands on a
// marketing page:
//   - signed-in users go to the /learn dashboard;
//   - everyone else goes to THE FIRST CHALLENGE, and is invited to register after it.
//
// CHANGED 2026-09-17 (Mr. Chen, item 4). This used to send an anonymous visitor to
// `/register?next=/learn`, and the comment here described the intent as "account first,
// then the first experience as the dashboard's one to-do". That is the order his decision
// reverses: "Experience the first opening challenge → explain the next five days and invite
// registration after that challenge … Do not place registration and all questionnaires
// before the first experience."
//
// A returning visitor with no session still reaches /login and /register directly, and the
// first challenge page shows "Already have an account? Sign in" from its first screen — so
// this is not a way of hiding the door, only of putting the experience in front of it.
// (Until 2026-09-23 that sentence was false: the only sign-in route was a door after the
// whole challenge. FlareSessionFirstPageSignIn.test.js now holds it.)
//
// The Keyhole pilot entry (/enter) is parked, not deleted (22 Aug): still routable by
// invite link, no longer the default funnel.
// KAN-488 option 1 (Ray, 14231, 9 Oct): when the server switch ENTRY_SIGNUP_FIRST is on, a
// signed-out visitor goes to sign-up FIRST (age, consent, guardian consent for 13-17), then
// straight into Challenge 1 from the dashboard. Off, everything above still holds.
export const SIGNUP_FIRST_TARGET = `/register?next=${LEARN_ROUTES.dashboard}`;

export default function RootRedirect() {
  const { isAuthenticated, loading } = useAuth();
  const config = useEntryConfig();
  if (loading || (!isAuthenticated && config.loading)) {
    return (
      <div className="flex-center" style={{ minHeight: '100vh' }}>
        <div className="spinner spinner-lg" />
      </div>
    );
  }
  return (
    <Navigate
      to={isAuthenticated ? LEARN_ROUTES.dashboard
        : (config.signupFirst ? SIGNUP_FIRST_TARGET : LEARN_ROUTES.flare)}
      replace
    />
  );
}
